import { Component } from '@angular/core';
import { AuthService } from '@core/authentication/auth.service';
import { combineLatest, debounceTime, map } from 'rxjs';

@Component({
  selector: 'app-landing',
  templateUrl: './landing.component.html',
  styleUrls: ['./landing.component.scss'],
})
export class LandingComponent {
  data = combineLatest([this.authService.getGroups(), this.authService.isLoggedIn()]).pipe(
    debounceTime(500),
    map(([groups, isLoggedIn]) => ({ groups, isLoggedIn }))
  );

  constructor(private authService: AuthService) {}
}
